import Repository from './Repository';

export default class OrderRepository extends Repository {
    protected basePath = 'orders';

    protected messages = {
        destroy: this.__('Rendelés sikeresen törölve.'),
        store: this.__('Rendelés sikeresen elmentve.'),
        update: this.__('Rendelés sikeresen frissítve.'),
    }

    protected redirects = {
        store: null
    }

    public export(data: object): Promise {
        console.error('Export method does not exist on OrderRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on OrderRepository.');
    }

    public storeBatch(products: object[]): Promise<any> {
        return new Promise((resolve, reject) => {
            this.request.post(this.basePath + '/batch', { products })
                .then((response: any) => {
                    this.request.message = this.messages.store;
                    this.request.status = 200;
                    this.request.title = this.__('Siker');

                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    }
}